import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Menu, MenuItem } from '@mui/material';
import { SubMenuIcon } from './Icons';

export type MenuDropdownProps = {
  anchorEl: null | HTMLElement;
  handleClose: any;
  items: any;
  title?: any;
  subtitle?: string;
  mt?: string;
  ml?: string;
  itemsPaddingRight?: string;
};

export default function MenuDropdown({
  anchorEl,
  handleClose,
  items,
  title,
  subtitle,
  mt = '',
  ml = '',
  itemsPaddingRight = '',
}: MenuDropdownProps) {
  return (
    <Menu
      sx={{ mt, ml }}
      id="menu-user-appbar"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={items?.length > 0 && Boolean(anchorEl)}
      onClose={handleClose}
      MenuListProps={{
        style: {
          padding: 0,
        },
      }}
      PaperProps={{
        style: {
          paddingTop: '5px',
          paddingBottom: '5px',
        },
      }}
    >
      {title && (
        <Box sx={{ padding: '20px', paddingBottom: '10px' }}>
          <Typography
            sx={{
              textTransform: 'capitalize',
              marginBottom: '4px',
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: 12 }}>{subtitle}</Typography>
          )}
        </Box>
      )}
      {items.map((setting: any) => (
        <MenuItem
          key={setting.name}
          disabled={setting.disabled}
          onClick={(e) =>
            setting.onClick(setting.onClickParam ? setting.onClickParam : e)
          }
          sx={{
            padding: '20px',
            paddingTop: '12px',
            paddingBottom: '12px',
            paddingRight: itemsPaddingRight,
            borderTop: setting.border
              ? '0.2px solid rgba(77, 82, 88, 0.2)'
              : '',
          }}
          data-testid={`settings-menu-${setting.name}`}
        >
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            {setting.icon !== false && (
              <Box sx={{ width: '24px', height: '24px' }}>{setting.icon}</Box>
            )}
            <Typography
              textAlign="center"
              data-testid={`menu-dropdown-option-${setting.name}`}
              sx={{
                marginLeft: setting.icon !== false ? '15px' : 0,
                marginRight: setting.hasSubMenu ? '15px' : 0,
                fontSize: 14,
              }}
            >
              {setting.name}
            </Typography>
            {setting.hasSubMenu && (
              <Box
                sx={{
                  marginLeft: 'auto',
                  marginRight: 0,
                  width: '8px',
                  height: '14px',
                }}
              >
                <SubMenuIcon />
              </Box>
            )}
          </Box>
        </MenuItem>
      ))}
    </Menu>
  );
}
